<script setup>

import FieldsTableRow from '../FieldsTableRow.vue'
import {computed, ref, watch} from "vue";

const props = defineProps({
  saving: Object,
  calculating: Boolean,
})
const emit = defineEmits(['calcDone'])
const inputSavingValue = ref(0)
const propCalculating = computed(() => {
  return props.calculating;
})
watch(inputSavingValue, () => {
  checkValid()
}) // Check input validity when value changes
watch(propCalculating, (newVal) => {
  if (newVal) calculateSaving()
}) // Do the calculation
const checkValid = () => {
  props.saving.valid = (parseInt(inputSavingValue.value) > 0);
}
const calculateSaving = () => {
  setTimeout(() => {
    props.saving.valueAnnual = parseInt(inputSavingValue.value);
    props.saving.valueWeekly = parseInt(inputSavingValue.value) / 52;
    emit('calcDone');

  }, 20);
}
</script>

<template>
  <FieldsTableRow v-bind:label="`Please input your annual State Pension`">
    <input v-model="inputSavingValue" type="number" min="0" step="1" :disabled="props.calculating">
  </FieldsTableRow>
  <FieldsTableRow v-bind:justText="true">
    You can get an estimate of your State Pension by visiting <a href="https://gov.uk/check-state-pension"
                                                                 target="_blank">www.gov.uk/check-state-pension</a>
  </FieldsTableRow>
</template>
